module.exports = __webpack_public_path__ + "media/images/icon__externalLink@2x-f19cf8b0a9168104582b8dcd07ed43fd.png";